/**
 * Constants for Embedded Dashboard
 */

import { API_BASE_URL } from '@/lib/api/config';

// API base URL
export const API_URL = API_BASE_URL;

// Feature flag for mock data in Settings Tab
export const USE_MOCK_DELIVERY_CONFIG =
  import.meta.env.VITE_USE_MOCK_DELIVERY_CONFIG === 'true';
